
import { useAuth } from "@/context/SafeAuthProvider";
import { cn } from "@/lib/utils";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { LogOut, Settings, User } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const ProfileButton = () => {
  const { user, signOut } = useAuth();
  const { darkMode } = useSettings();
  const navigate = useNavigate();
  const location = useLocation();

  // Check if we're currently on the settings page
  const isOnSettingsPage = location.pathname === '/settings';

  console.log("ProfileButton render:", { 
    isOnSettingsPage, 
    pathname: location.pathname,
    user: user ? "authenticated" : "not authenticated"
  });

  if (!user) {
    return (
      <Button
        variant="ghost"
        className={cn(
          "gap-2",
          darkMode ? "text-[#FBF3F1] hover:bg-[#6127A0]/20" : "hover:bg-[#6127A0]/10"
        )}
        onClick={() => navigate("/auth")}
      >
        <User className="h-5 w-5" />
        <span>Sign In</span>
      </Button>
    );
  }

  const handleSettingsClick = () => {
    console.log("Settings navigation clicked from ProfileButton");
    navigate('/settings');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className={cn(
            "gap-2",
            darkMode ? "text-[#FBF3F1] hover:bg-[#6127A0]/20" : "hover:bg-[#6127A0]/10"
          )}
        >
          <User className="h-5 w-5" />
          <span>Account</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={cn(
          "w-56",
          darkMode ? "bg-[#2d1a45] border-[#6127A0]/50 text-[#FBF3F1]" : ""
        )}
      >
        <DropdownMenuLabel>My Account</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem disabled>
          <span className="truncate">{user?.email}</span>
        </DropdownMenuItem>
        <DropdownMenuItem disabled>
          <span>Plan: Free</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        {!isOnSettingsPage && (
          <DropdownMenuItem onClick={handleSettingsClick}>
            <Settings className="h-4 w-4 mr-2" />
            <span>Settings</span>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={() => signOut()}>
          <LogOut className="h-4 w-4 mr-2" />
          <span>Sign out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ProfileButton;
